import { loadStripe } from "@stripe/stripe-js";
import stripeConfig from "./config_stripe.json";

export const stripePromise = loadStripe(stripeConfig.pk);